<template>
  <div class="content-container" v-loading="loading" style="padding:0 100px">
    <el-button class="btn-reset" style="float:right;margin-right:35px" @click="toHistoryPage">查看历史配置</el-button>
    <div class="buTaskContainer" v-for="item in taskConfigList" :key="item.orgCode">
      <div class="buName">所属BU: {{item.orgCodeName}}</div>
      <div height="150px" :autoplay="false" class="menu-row" indicator-position="none" :loop="false">
        <div class="menu-list" v-for="(cItem, index) in item.tradePerfectThemeDefineDTOList" :key="index">
          <div class="menu-item" v-for="(sItem,cIndex) in cItem" :key="cIndex">
            <div class="menu-title" :class="{'wait-submit-bg':sItem.themeStatus === 0 || sItem.alreadyConfiguredQty !== 1,'effect-bg':sItem.themeStatus === 200 && sItem.alreadyConfiguredQty === 1,'disable-bg':sItem.publishStatus === 0,'overdue-bg':sItem.themeStatus === 900}">
              <span class="themeName" :title="sItem.themeName">{{sItem.themeName}}</span>
              <span style="font-size:16px">{{sItem.channelName}}</span>
            </div>
            <div class="menu-goConfiguration" v-if="sItem.alreadyConfiguredQty != 1" @click="goConfiguration(sItem.themeDefineId ,item.orgCode)" style="color:#2081e6;font-size:16px">
              <i class="el-icon-edit" style="color:#2081e6;margin-right:5px"></i>
              <p>去配置</p>
            </div>
            <div class="menu-configuration"  v-else @click="goView(sItem)">
              <div class="menu-task" :class="{'wait-submit-border':sItem.themeStatus === 0 || sItem.alreadyConfiguredQty !== 1,'effect-border':sItem.themeStatus === 200 && sItem.alreadyConfiguredQty === 1,'disable-border':sItem.publishStatus === 0,'overdue-border':sItem.themeStatus === 900}">
                <div v-if="sItem.taskTypeNameScope.length">{{sItem.taskTypeNameScope.replace(/,/g , '+')}}</div>
                <div v-else style="color:#2081e6">完善任务配置</div>
                <!-- <span :class="sItem.publishStatus === 0?'red':'green'" class="menu-status">{{sItem.publishStatus === 0?'已禁用':sItem.themeStatusName}}</span> -->
              </div>
              <div class="menu-data">{{sItem.startDate | parseTime("{y}-{m}-{d}")}}至 {{sItem.endDate | parseTime("{y}-{m}-{d}")}}</div>
            </div>
            <div class="menu-status" v-if="sItem.alreadyConfiguredQty === 1" :class="{'wait-submit-bg':sItem.themeStatus === 0 || sItem.alreadyConfiguredQty !== 1,'effect-bg':sItem.themeStatus === 200 && sItem.alreadyConfiguredQty === 1,'disable-bg':sItem.publishStatus === 0,'overdue-bg':sItem.themeStatus === 900,
              'wait-submit-text':sItem.themeStatus === 0 || sItem.alreadyConfiguredQty !== 1,'effect-text':sItem.themeStatus === 200 && sItem.alreadyConfiguredQty === 1,'disable-text':sItem.publishStatus === 0,'overdue-text':sItem.themeStatus === 900
            }">{{sItem.publishStatus === 0?'已禁用':sItem.themeStatusName}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="no-data" v-if="taskConfigList.length < 1">暂无数据</div>
  </div>
</template>

<script>
import tradeApi from '@/api/trade'
export default {
  name: 'perfect-theme-list',
  data () {
    return {
      taskConfigList: []
    }
  },
  created () {
    this.getPerfectTasksConfigList()
  },
  methods: {
    // 获取任务配置信息
    getPerfectTasksConfigList () {
      this.loading = true
      tradeApi.getPerfectTasksConfigList({ themeVersion: '202208' }).then(res => {
        this.loading = false
        if (res.data.resultCode === '0') {
          this.taskConfigList = res.data.resultData.parentThemeDefineList || []
          this.taskConfigList.forEach(item => {
            item.tradePerfectThemeDefineDTOList = this.checkArray(item.tradePerfectThemeDefineDTOList)
          })
        }
      })
        .catch(() => {
          this.loading = false
        })
    },
    // 处理数据适配轮播(原来是轮播，现在改为平铺，如需改为轮播，只需将html中menu-list及其父标签改为轮播标签，并取消margin-top即可)
    checkArray (data) {
      let newData = new Array(Math.ceil(data.length / 3))
      for (let i = 0; i < newData.length; i++) {
        newData[i] = data.slice(i * 3, (i + 1) * 3)
      }
      return newData
    },
    goConfiguration (id, orgCode) {
      this.$router.push({ name: 'perfect-bu-config', query: { themeDefineId: id, orgCode: orgCode, type: 'config' } })
    },
    goView (themeDefine) {
      if (themeDefine.themeStatus === 0) {
        // 待提交状态活动直接进编辑页面
        this.$router.push({
          name: 'perfect-bu-config',
          query: {
            themeDefineId: themeDefine.themeDefineId,
            type: 'update',
            status: themeDefine.themeStatus
          }
        })
      } else {
        this.$router.push({ name: 'perfect-bu-view', query: { themeDefineId: themeDefine.themeDefineId, type: 'view' } })
      }
    },
    // 查看历史配置
    toHistoryPage () {
      this.$router.push({
        path: '/perfect/history-bu-list'
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.buName {
  font-size: 16px;
  // line-height: 40px;
  margin-left: 35px;
}
.menu-row {
  width: 100%;
  margin: 40px 0;
  color: #101010;
  .menu-list {
    margin-top: 40px;
    display: flex;
    // justify-content: space-between;
  }
  .menu-item {
    width: 267px;
    height: 145px;
    margin: 0 35px;
    text-align: center;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    box-shadow: 0px 0px 16px #eaeaea;
    .menu-title {
      padding: 8px 10px;
      display: flex;
      justify-content: space-between;
      // border-bottom: 1px solid #bbb;
    }
    .themeName {
      max-width: 120px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 16px;
    }
    .menu-goConfiguration {
      // padding-top: 25px;
      margin-top: 10px;
      height: 95px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        font-size: 20px;
        color: #bbbbbb;
      }
      p {
        color: #59a6ff;
      }
    }
    .menu-configuration {
      cursor: pointer;
      height: 77px;
      text-align: left;

      .menu-task {
        text-align: center;
        font-size: 16px;
        line-height: 77px;
        // border-bottom: 1px solid #ddd;
        .green {
          color: #64d795;
          border: 1px solid #64d795;
        }
        .red {
          color: #cd1231;
          border: 1px solid #cd1231;
        }
      }
      .menu-data {
        line-height: 34px;
        padding: 0 10px;
        color: #666;
      }
    }
    .menu-status {
          position: absolute;
          right: 0;
          bottom: 0px;
          padding: 4px 13px 4px 15px;
          border-top-left-radius: 16px;
          // border-bottom-left-radius: 15px;
        }
    .no-data {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 200px;
    }
    .require {
      position: relative;
      &::before {
        content: '*';
        font-size: 20px;
        width: 5px;
        height: 5px;
        color: red;
        position: absolute;
        top: 0;
        left: -10px;
      }
    }
  }
}
// .el-carousel__arrow--right {
//     right: -3px;
// }
.wait-submit-bg{
  background-color: #D0EEF9;
}
.wait-submit-text{
  color: #1DACE4;
}
.wait-submit-border{
  border-bottom: 1px solid #D0EEF9;
}
.effect-bg{
  background-color: #DAEEE2;
}
.effect-border{
  border-bottom: 1px solid #DAEEE2;
}
.effect-text{
  color: #95CEAB;
}
.disable-bg{
  background-color: #FBD7CB;
}
.disable-border{
  border-bottom: 1px solid #FBD7CB;
}
.disable-text{
  color: #E95429;
}
.overdue-bg{
  background-color: #e9e9e9;
}
.overdue-border{
  border-bottom: 1px solid #e9e9e9;
}
.overdue-text{
  color: #ccc;
}
.btn-reset {
  background-color: #bbb;
  color: #ffffff;
}
</style>
